import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./FaqSection.scss";

function FaqSection(props) {
  // Object to store expanded state for all items
  const [expanded, setExpanded] = useState({});
  // Set an item's expanded state
  const setExpandedItem = (index, isExpanded) => {
    setExpanded({
      ...expanded,
      [index]: isExpanded,
    });
  };

  const items = [
    {
      question: "What is CodePrompt?",
      answer:
        "CodePrompt is a tool to help you code faster and better. CodePrompt requires a licence key and an OpenAI key to work.",
    },
    {
      question: "What is a licence key?",
      answer: "CodePrompt requires a licence purchase.",
    },
    {
      question: "What is an OpenAI key?",
      answer:
        "CodePrompt requires an OpenAI key. It does not require a ChatGPT Plus subscription.",
    },
    {
      question: "Which languages are supported?",
      answer:
        "CodePrompt currently offers has hints for JavaScript, TypeScript, React and Bootstrap. CodePrompt can answer coding question for all languages. Ensure you include and language and framework details in your prompt.",
    },
    {
      question: "Is my data safe?",
      answer:
        "All your data is stored locally in your browser. We do not store any of your data on our servers.",
    },
    {
      question: "What is the refund policy?",
      answer:
        "If you are not completely satisfied with your purchase, you can request a refund at support@evergreenapps.co.uk within 14 days of your purchase.",
    },
  ];

  return (
    <Section
      id={props.id}
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        />

        {items.map((item, index) => (
          <article
            className="FaqSection__faq-item py-4"
            onClick={() => {
              setExpandedItem(index, !expanded[index]);
            }}
            key={index}
          >
            <h4>
              <span className="text-primary mr-3">
                <i
                  className={
                    "fas" +
                    (expanded[index] ? " fa-minus" : "") +
                    (!expanded[index] ? " fa-plus" : "")
                  }
                />
              </span>
              {item.question}
            </h4>

            {expanded[index] && <div className="mt-3">{item.answer}</div>}
          </article>
        ))}
      </Container>
    </Section>
  );
}

export default FaqSection;
